
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es",
      function () {
        return require("private-next-pages/es.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es"])
      });
    }
  